<template>
  <div>
    <div
      class="message"
      v-for="(message, index) in messages"
      v-bind:key="index"
      :class="{'incoming': message.sender !== myPeerDid}"
    >
      <div
        class="username"
        v-if="(index > 0 && conversation.messages[index - 1].sender != message.sender) || index === 0">
        <v-avatar size="28" class="avatar" v-if="avatarImage(message.sender)">
          <v-img :src="avatarImage(message.sender)"></v-img>
        </v-avatar>
        <v-avatar small size="28" class="avatar" color="accent" v-else>
          <span style="font-size: 10px"> {{ avatarLetters(message.sender) }}</span>
        </v-avatar>
        <span class="ml-2 mr-2">{{ messageUser(message.sender) }}</span>
      </div>
      <div style="margin-top: 5px"></div>
      <div class="content" v-if="(message.message_type || 0) === 0" v-html="message.body"></div>
      <RTCMessage v-if="(message.message_type || 0) === 1" :message="message"  @joinRTC="joinRTC"></RTCMessage>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RTCMessage from '@/components/RTCMessage'

export default {
  data () {
    return {};
  },
  props: ['conversation'],
  components: { RTCMessage },
  computed: {
    myPeerDid () {
      const rawDid = this.conversation.meta.peerDid
      const did = JSON.parse(rawDid)
      return did.id
    },
    messages () {
      return this.conversation ? this.conversation.messages || [] : []
    },
    ...mapGetters({
      user: 'hearro/loggedInUser'
    })
  },
  methods: {
    joinRTC (sessionId) {
      console.log('emit joinRTC')
      this.$emit('joinRTC', sessionId)
    },
    messageUser (participantId) {
      const p = this.conversation.participants.find(p => {
        return p.doc.id === participantId
      })
      if (!p) {
        this.$store.dispatch('hearro/loadConversations')
        return ''
      }
      return p.entity.name.Label || `${p.entity.name.First} ${p.entity.name.Last}`
    },
    avatarImage (participantId) {
      const p = this.conversation.participants.find(p => {
        return p.doc.id === participantId
      })
      if (!p) {
        this.$store.dispatch('hearro/loadConversations')
        return false
      }
      if (!p.entity.image) {
        return false
      }
      return p.entity.image.find(e => e.type === 'avatar').location || false
    },
    avatarLetters (participantId) {
      const p = this.conversation.participants.find(p => {
        return p.doc.id === participantId
      })
      if (!p) {
        this.$store.dispatch('hearro/loadConversations')
        return ''
      }
      if (!p.entity || !p.entity.name) {
        return ''
      }
      let initials = ''
      if (p.entity.name.First) {
        initials = p.entity.name.First.substring(0, 1)
      }
      if (p.entity.name.Last) {
        initials = initials.concat('', p.entity.name.Last.substring(0, 1))
      }

      return initials
    },
    primaryContactEmail (e) {
      console.log('contact email', e)
      const c = e.entity.contact.find(c => c.type === 'primary')
      return c.email[0].address || {}
    }
  }
}
</script>

<style>
span.emoji {
  font-size: 20px;
  vertical-align: middle;
  line-height: 2;
}
.message {
  margin-bottom: 3px;
}
.message.own {
  text-align: right;
}
.message.own .content {
  background-color: lightskyblue;
}
.username {
  font-size: 18px;
  font-weight: bold;
}
.content {
  padding: 8px;
  background-color: lightsteelblue;
  border-top-left-radius: 0px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  display: inline-block;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 2px 1px -1px rgba(0, 0, 0, 0.12);
  max-width: 50%;
  word-wrap: break-word;
}
.incoming {
  text-align: right;
}
.incoming .content{
  border-top-left-radius: 10px;
  border-top-right-radius: 0px;
  background-color: lightblue;
}
.incoming .avatar{
  float: right;
}
</style>
